import React, { useState } from 'react';

import { CliveChip } from '~/components/AiChat/CliveChip/CliveChip';
import type { CliveAction } from '~/components/types/claim-document-types';
import type { ClaimPolymorph } from '~/components/types/claim-types';
import { reportErrorInProductionOrThrow } from '~/Utils';

import CliveInvoiceActionContainer from './CliveInvoiceActionContainer';

// Document type matching claim.documents
type ClaimDocument = NonNullable<ClaimPolymorph['documents']>[number];

interface CliveDocumentActionChipProps {
  document: ClaimDocument;
  action: CliveAction;
}

/**
 * Renders the appropriate chip and dialog for a CliveAction based on its task_type.
 * Currently supports: invoice_analysis_recommendation
 * Extensible for future task types.
 */
const CliveDocumentActionChip: React.FC<CliveDocumentActionChipProps> = ({ document, action }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleChipClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  // Render based on task type
  switch (action.task_type) {
    case 'invoice_analysis_recommendation':
      return (
        <>
          <button type="button" onClick={handleChipClick} className="cursor-pointer border-0 bg-transparent p-0">
            <CliveChip iconType="happy" content="Invoice" />
          </button>
          {isDialogOpen && (
            <CliveInvoiceActionContainer
              document={document}
              action={action}
              open={isDialogOpen}
              onClose={handleDialogClose}
            />
          )}
        </>
      );

    default:
      // Unknown task type - don't render anything
      reportErrorInProductionOrThrow(`Unknown task type: ${action.task_type} for document: ${document.id}`);
      return null;
  }
};

export default CliveDocumentActionChip;
